// initial state
const state = () => ({
    activeModal: null,
});

// getters
const getters = {};

// actions
const actions = {
    clickModalOverlay: function ({ commit }, event) {
        if (
            event.srcElement.classList.contains("overlay") &&
            event.target.classList.contains("overlay")
        ) {
            this.dispatch("modals/closeModals");
        }
    },
    closeModals({ commit }) {
        commit("setActiveModal", null);
        document
            .getElementById("app")
            .classList.remove("overflow-hidden", "vh-100");
    },
    openModal({ commit }, modal) {
        commit("setActiveModal", modal);
        document
            .getElementById("app")
            .classList.add("overflow-hidden", "vh-100");
    },
};

// mutations
const mutations = {
    setActiveModal(state, modalName) {
        state.activeModal = modalName;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
